import { FARO_INIT_ATTRIBUTE } from "./constants";
import { getElementDataAttribute, setElementDataAttribute } from "../util/attr";
const FARO_SCRIPT_ID = "op-sso__script__faro";
const FARO_ATTRIBUTES_WAIT_TIMEOUT = 10000;
let _faroScript = null;
const getFaroScript = () => {
    _faroScript !== null && _faroScript !== void 0 ? _faroScript : (_faroScript = document.getElementById(FARO_SCRIPT_ID));
    if (!_faroScript) {
        console.error("Faro script not found");
    }
    return _faroScript;
};
export const getFaroInitAttribute = (attribute, defaultValue = "") => {
    const faroScript = getFaroScript();
    if (!faroScript) {
        return "";
    }
    return getElementDataAttribute(faroScript, attribute) || defaultValue;
};
export const setFaroInitAttribute = (attribute, value) => {
    const faroScript = getFaroScript();
    if (!faroScript) {
        return;
    }
    setElementDataAttribute(faroScript, attribute, value);
};
export const waitForFaroInitAttributes = () => {
    let resolveAttributesPromise;
    let rejectAttributesPromise;
    const attributesPromise = new Promise((resolve, reject) => {
        resolveAttributesPromise = resolve;
        rejectAttributesPromise = reject;
    });
    const observedAttributes = [FARO_INIT_ATTRIBUTE.TraceId, FARO_INIT_ATTRIBUTE.SessionId];
    const allAttributesSet = () => observedAttributes.every((attr) => !!getFaroInitAttribute(attr));
    // Attributes already set, resolve and exit
    if (allAttributesSet()) {
        resolveAttributesPromise();
        return attributesPromise;
    }
    const waitForAttributesTimeout = setTimeout(() => {
        console.error("Timeout waiting for Faro attributes");
        observer.disconnect();
        rejectAttributesPromise(new Error("Timeout waiting for Faro attributes"));
    }, FARO_ATTRIBUTES_WAIT_TIMEOUT);
    const observer = new MutationObserver(() => {
        if (allAttributesSet()) {
            observer.disconnect();
            clearTimeout(waitForAttributesTimeout);
            resolveAttributesPromise();
        }
    });
    const faroScript = getFaroScript();
    if (!faroScript) {
        rejectAttributesPromise(new Error("Faro script not found"));
        return attributesPromise;
    }
    observer.observe(faroScript, {
        attributes: true,
        attributeFilter: observedAttributes.map((attr) => `data-${attr.toLowerCase()}`),
        subtree: false,
        childList: false,
        characterData: false,
    });
    return attributesPromise;
};
